class Account extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    window.addEventListener('load', () => {
      setTimeout(function () {
        var smile = window.Smile;

        smile
          .fetchCustomer()
          .then((customer) => {
            document.querySelector('.skull-points').innerHTML =
              customer.points_balance;
          })
          .catch((error) => {
            console.error(error);
          });
      }, 2000);
    });
  }
}

customElements.define('account-page', Account);
